import ReactTooltip from 'react-tooltip';
import { useEffect, useRef, useState } from 'react';
import { GetMonitors } from '../common/uptimerobot';
import { formatDuration, formatNumber } from '../common/helper';
import Link from './link';

function UptimeRobot({ apiToken, onChange }) {

  const status = {
    ok: '正常',
    down: '无法访问',
    unknow: '未知'
  };

  const { CountDays, ShowLink } = window.Config;

  const [monitors, setMonitors] = useState();
  const [error, setError] = useState();

  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    let active = true;

    setMonitors(undefined);
    setError(undefined);
    GetMonitors(apiToken, CountDays)
      .then((data) => {
        if (!active) return;
        setMonitors(data);
        if (onChangeRef.current) onChangeRef.current({ monitors: data });
      })
      .catch((requestError) => {
        if (!active) return;
        const message = requestError.response?.data?.message || requestError.message || '请求失败';
        setError(message);
        if (onChangeRef.current) onChangeRef.current({ error: message });
      });

    return () => {
      active = false;
    };
  }, [apiToken, CountDays]);

  if (error) return (
    <div className='item error'>
      UptimeRobot API：{error}
    </div>
  );

  if (monitors) return monitors.map((site) => (
    <div key={site.id} className='item'>
      <div className='meta'>
        <div className='info'>
          <span className='name' dangerouslySetInnerHTML={{ __html: site.name }} />
          {ShowLink && <Link className='link' to={site.url} text={site.name} />}
        </div>
        <span className={'status ' + site.status}>{status[site.status]}</span>
      </div>
      <div className='timeline'>
        {site.daily.map((data, index) => {
          let status = '';
          let text = data.date.format('YYYY-MM-DD ');
          if (data.uptime >= 100) {
            status = 'ok';
            text += `可用率 ${formatNumber(data.uptime)}%`;
          }
          else if (data.uptime <= 0 && data.down.times === 0) {
            status = 'none';
            text += '无数据';
          }
          else {
            status = 'down';
            text += `故障 ${data.down.times} 次，累计 ${formatDuration(data.down.duration)}，可用率 ${formatNumber(data.uptime)}%`;
          }
          return (<i key={index} className={status} data-tip={text} />)
        })}
      </div>
      <div className='foot'>
        <span>今天</span>
        <span>
          {site.total.times
            ? `最近 ${CountDays} 天故障 ${site.total.times} 次，累计 ${formatDuration(site.total.duration)}，平均可用率 ${site.average}%`
            : `最近 ${CountDays} 天可用率 ${site.average}%`}
        </span>
        <span>{site.daily[site.daily.length - 1].date.format('YYYY-MM-DD')}</span>
      </div>
      <ReactTooltip className='tooltip' place='top' type='dark' effect='solid' />
    </div>
  ));

  else return (
    <div className='item loading' />
  );
}

export default UptimeRobot;
